module.exports = __webpack_public_path__ + "static/seungwoo_hong-a3d9ad29f2a8d12053284a536c76d939.jpeg";